import CircleCheck from '@otovo/shared/images/icons/circle-check.svg';
import cx from 'classnames';

type Props = {
  children: React.ReactNode;
  className?: string;
};

const UnorderedListItem = ({ children, className }: Props) => (
  <li className={cx('flex items-start text-balance', className)}>
    <CircleCheck className="mt-[1px] mr-2 size-4 shrink-0 fill-green-70 text-white md:size-5" />
    <div>{children}</div>
  </li>
);

export default UnorderedListItem;
